import React, { useState, useCallback, useEffect } from 'react';
import { IoMdTrash } from 'react-icons/io';
// import _ from 'lodash';

import CButton from '../../../components/button/button';
import CModal from '../../../components/modal/modal';
import AddLegislation from '../../../components/forms/add_legislation';
import CSearchBar from '../../../components/search-bar/search_bar';
import Tabs from '../../../components/vertical-tab/tabs';
import {
  TypeLegislation,
  EntryLegislation,
  types_legislation
} from '../../../types/menu-legislation';
import styles from '../../legislation/legislation.module.scss';
import {
  addLegislationAdmin,
  deleteLegislationAdmin,
  downloadOneLegislationAdmin,
  getAllLegislationAdmin
} from '../../../network/legislation';
import { notify } from '../../../notifications/notification';
import { Space } from '../../../components/utils/utils';
import { variables } from '../../../utils/variables';

const LegislationAdmin = () => {
  const [currOption, setOption] = useState(types_legislation[0]);
  const [filterValue, setValue] = useState('');
  const [list, setList] = useState([]);
  const [unfiltered, setUnfiltered] = useState([]);
  const [openedModal, setModal] = useState(false);

  useEffect(() => {
    getAllLegislationAdmin(data => {
      // const grouped = _.mapValues(
      //   _.groupBy(data, 'type'),
      //   (list: EntryLegislation[]) =>
      //     list.map((option: EntryLegislation) => _.omit(option, 'type'))
      // );

      setList(data);
      setUnfiltered(data);
    });
    // getAllLegislationAdmin(data => setUnfiltered(data));
  }, []);

  useEffect(() => {
    setList(
      unfiltered.filter((option: EntryLegislation) =>
        option.name.toUpperCase().includes(filterValue.toUpperCase())
      )
    );
    // eslint-disable-next-line
  }, [filterValue]);

  const handleChange = useCallback(
    (value: TypeLegislation) => {
      setOption(value);
    },
    [setOption]
  );

  const handleFilter = (event: React.ChangeEvent<any>) => {
    const { value } = event.target;
    setValue(value);
  };

  const addNewDoc = () => {
    setModal(!openedModal);
  };

  const deleteDoc = (id: number) => {
    deleteLegislationAdmin(id, () => {
      notify('Ati sters cu succes o legislatie!', 'success');
      getAllLegislationAdmin(data => setList(data));
    });
  };

  return (
    <div className={styles.container}>
      <CModal opened={openedModal} openModal={setModal}>
        <AddLegislation
          type={currOption.key}
          submit={addLegislationAdmin}
          callback={() => {
            setModal(false);
            getAllLegislationAdmin(data => setList(data));
          }}
        />
      </CModal>
      <Tabs
        options={types_legislation}
        currentOption={currOption}
        onChange={handleChange}
      />
      <CButton
        label='Adăugați un fișier nou'
        onClick={addNewDoc}
        type='button'
        className={styles.add}
      />
      <div className={styles.content}>
        <CSearchBar value={filterValue} onChange={handleFilter} />
        {/* <p className='body-dark faded'>
          {`Ati introdus ${list.length} fisiere`}
        </p> */}
        <Space vertical={variables.verticalSpace} />
        <div className={styles.list}>
          {list.length > 0 &&
            list.map(
              (option: EntryLegislation) =>
                option.type === currOption.key && (
                  <div className={styles.set} key={option.id}>
                    <CButton
                      label={`Descărcați ${option.name}`}
                      type='button'
                      onClick={() =>
                        downloadOneLegislationAdmin(option.id, option.name)
                      }
                    />
                    <CButton
                      label={<IoMdTrash />}
                      type='button'
                      onClick={() => deleteDoc(option.id)}
                    />
                  </div>
                )
            )}
        </div>
      </div>
    </div>
  );
};

export default LegislationAdmin;
